export const fontWeights = {
  lato: {
    thin: 100,
    light: 300,
    regular: 400,
    bold: 700,
    black: 900,
    medium: 500,
    semiBold: 600,
    extrabold: 800,
  },
  asap: {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
  },
  inter: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
  },
} as const;